import React from 'react';
import BrandLogo from '../BrandLogo';
import { PLATFORM_COMPANY } from '../../constants/platformCompany';
import './PlatformCompanyInfo.css';

export interface PlatformCompanyInfoProps {
  /** 랜딩 스크롤 리빌용 */
  reveal?: boolean;
  className?: string;
}

const PlatformCompanyInfo: React.FC<PlatformCompanyInfoProps> = ({
  reveal = false,
  className,
}) => {
  const rootClass = [
    'landing-company-info',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <footer
        className={rootClass}
        {...(reveal ? { 'data-landing-reveal': true } : {})}
      >
        <div className="landing-company-info-inner">
          <p className="landing-company-brand">
            <BrandLogo className="cp-brand-logo--sidebar" />
          </p>
          <div className="landing-company-text">
            <div>{PLATFORM_COMPANY.operatorLine}</div>
            <div>{PLATFORM_COMPANY.mailOrderLicense}</div>
            <div>{PLATFORM_COMPANY.businessNumber}</div>
            <div>{PLATFORM_COMPANY.address}</div>
            <div className="landing-company-policy-links">
              <a className="landing-company-policy-link" href="/terms">
                [서비스 이용약관]
              </a>
              <a className="landing-company-policy-link" href="/privacy">
                [개인정보처리방침]
              </a>
            </div>
            <div>{PLATFORM_COMPANY.phone}</div>
            <div>
              {PLATFORM_COMPANY.supportEmailLabel} :{' '}
              <a
                className="landing-company-mail"
                href={`mailto:${PLATFORM_COMPANY.supportEmail}`}
              >
                {PLATFORM_COMPANY.supportEmail}
              </a>
            </div>
          </div>
        </div>
      </footer>

    </>
  );
};

export default PlatformCompanyInfo;
